import { Component, ViewChild } from '@angular/core';
import {
  AddEstimationGroupMeteringPointsCommand,
  EstimationGroupMeteringPointSearchResult,
  EstimationGroupMeteringPointsService,
  EstimationGroupsService,
  MeteringPointType,
} from '@app/api/dmc';
import { ModalService } from '@app/core/services/modal.service';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { estimationGroupMeteringPointTable } from '@shared/table-configs/vee/vee-meteringpoint.table';
import { TableComponent } from '@shared/components/table/table.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VeeMeteringPointFormGroup } from '@shared/modals/vee/vee-meteringpoint.formgroup';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { removeNullValues } from '@app/core/utils/remove-null-values';
import { ToastService } from '@app/core/services/toast.service';
import { Observable } from 'rxjs';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { SortParam } from '@app/core/constants/sort-param';

@Component({
  selector: 'app-vee-meteringpoint-attach',
  imports: [
    TableComponent,
    ButtonDirective,
    FormsModule,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe,
    SelectDirective
  ],
  templateUrl: './vee-meteringpoint-attach.component.html',
  styleUrl: './vee-meteringpoint-attach.component.css'
})
export class VeeMeteringpointAttachComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  /** Form **/
  public searchForm: FormGroup = new FormGroup({
    ... VeeMeteringPointFormGroup,
    meteringPointNoEstimationGroup: new FormControl(false),
    estimationGroupName: new FormControl(null),
  });

  /** Options **/
  public meteringPointTypeOptions: KeyValue[] = enumToKeyValue(MeteringPointType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.meteringpointtype.' });

  /** Selected Elements **/
  public selectedElements: EstimationGroupMeteringPointSearchResult[] = [];

  /** Estimation Group ID **/
  public estimationGroupId?: string;

  /** Table **/
  public tableConfig: TableConfig<EstimationGroupMeteringPointSearchResult> = {
    ...estimationGroupMeteringPointTable,
    serviceCallback: (pageSize: number, page: number, order?: SortParam) => this.search(pageSize, page, order),
  }

  constructor(
    private readonly estimationGroupMeteringPointsService: EstimationGroupMeteringPointsService,
    private readonly estimationGroupsService: EstimationGroupsService,
    private readonly modalService: ModalService,
    private readonly toastService: ToastService,
  ) {

  }

  public search(pageSize: number, page: number, order?: SortParam): Observable<any> {
    const sort = order ? { SortParams: [order] } : {};
    const data = removeNullValues(this.searchForm.value);
    return this.estimationGroupsService.veeEstimationGroupsMeteringpointsSearchPost({ ...data, page, pageSize, ...sort });
  }

  public submit(): void {
    if (this.selectedElements.length > 0) {
    this.searchForm.markAllAsTouched();

    const meteringPointIds: string[] = this.selectedElements.flatMap((item: EstimationGroupMeteringPointSearchResult) => item.meteringPointId ? [item.meteringPointId] : []);

      const data: AddEstimationGroupMeteringPointsCommand = { meteringPointIds: meteringPointIds }

      this.estimationGroupMeteringPointsService.veeEstimationgroupsEstimationGroupIdMeteringpointsPost(this.estimationGroupId ?? '', data).subscribe(() => {
        this.toastService.show('vee.meteringpoint.meteringpointattached');
        this.modalService.close();
      })
    }
  }
}
